import { Injectable } from '@angular/core';

import { cloneDefaultTableSettings, SavedTableSettings, TableSelectedItem } from '../models';

@Injectable({ providedIn: 'root' })
export class SessionStorageService {
  setItem(key: string, value: any) {
    try {
      const serializedValue = JSON.stringify(value);

      sessionStorage.setItem(key, serializedValue);
    } catch (e) {
      console.error('Error saving to sessionStorage', e);
    }
  }

  getItem<T>(key: string) {
    try {
      const serializedValue = sessionStorage.getItem(key);

      return serializedValue ? JSON.parse(serializedValue) as T : null;
    } catch (e) {
      console.error('Error reading from sessionStorage', e);

      return null;
    }
  }

  getFilters(key: string) {
    try {
      const serializedValue = sessionStorage.getItem(key);

      return serializedValue ? JSON.parse(serializedValue).filters as Record<string, string | string[]> : null;
    } catch (e) {
      console.error('Error reading from sessionStorage', e);

      return null;
    }
  }

  getColumns(key: string) {
    try {
      const serializedValue = sessionStorage.getItem(key);

      return serializedValue ? JSON.parse(serializedValue).columns as string[] : null;
    } catch (e) {
      console.error('Error reading from sessionStorage', e);

      return null;
    }
  }

  saveColumnsSettingsToSessionStorage(key: string, columns: string[]) {
    const tableSettings: SavedTableSettings = this.getItem(key) || cloneDefaultTableSettings();

    tableSettings.columns = columns;
    try {
      const serializedValue = JSON.stringify(tableSettings);

      sessionStorage.setItem(key, serializedValue);
    } catch (e) {
      console.error('Error saving to sessionStorage', e);
    }
  }

  saveFiltersToSessionStorage(key: string, filters: { [key: string]: string | string[]; }) {
    const tableSettings: SavedTableSettings = this.getItem(key) || cloneDefaultTableSettings();

    tableSettings.filters = filters;
    try {
      const serializedValue = JSON.stringify(tableSettings);

      sessionStorage.setItem(key, serializedValue);
    } catch (e) {
      console.error('Error saving to sessionStorage', e);
    }
  }

  getLastSelectedItems(key: string) {
    try {
      const serializedValue = sessionStorage.getItem(key);

      return serializedValue ? JSON.parse(serializedValue).lastSelectedItems as TableSelectedItem[] : null;
    } catch (e) {
      console.error('Error reading from sessionStorage', e);

      return null;
    }
  }

  saveLastSelectedItems(key: string, item: TableSelectedItem) {
    const tableSettings: SavedTableSettings = this.getItem(key) || cloneDefaultTableSettings();
    const existingItemIndex = tableSettings.lastSelectedItems.findIndex(
      (selectedItem: TableSelectedItem) =>
        selectedItem.url[selectedItem.url.length - 1] === item.url[item.url.length - 1],
    );

    if (existingItemIndex !== -1) {
      tableSettings.lastSelectedItems.splice(existingItemIndex, 1);
    }
    tableSettings.lastSelectedItems.unshift(item);

    try {
      const serializedValue = JSON.stringify(tableSettings);

      sessionStorage.setItem(key, serializedValue);
    } catch (e) {
      console.error('Error saving to sessionStorage', e);
    }
  }

  removeItem(key: string) {
    sessionStorage.removeItem(key);
  }

  clear() {
    sessionStorage.clear();
  }
}
